import { render } from "./RadarChart.vue?vue&type=template&id=fd72cc6a"
import script from "./RadarChart.vue?vue&type=script&lang=ts"
export * from "./RadarChart.vue?vue&type=script&lang=ts"
script.render = render

export default script